import clsx from 'clsx';

const MapIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className, 'fill-current')}
    width="22"
    height="28"
    viewBox="0 0 22 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.64 28C10.64 28 21.28 16.8534 21.28 10.8571C21.28 4.86091 16.5163 0 10.64 0C4.76369 0 0 4.86091 0 10.8571C0 16.8534 10.64 28 10.64 28ZM10.64 15.68C13.4235 15.68 15.68 13.4235 15.68 10.64C15.68 7.85651 13.4235 5.60003 10.64 5.60003C7.85651 5.60003 5.60003 7.85651 5.60003 10.64C5.60003 13.4235 7.85651 15.68 10.64 15.68Z"
    />
  </svg>
);
export default MapIcon;
